import { z } from 'zod';

/**
 * A schema that can be used with filters that can be 'Y' (yes), 'N' (no), or '' (both).
 */
export const yesNoOrBothSchema = z.union([z.literal('Y'), z.literal('N'), z.literal('')]);

export type YesNoOrBothValue = z.infer<typeof yesNoOrBothSchema>;
